import { createContext, useState } from 'react';

import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  ModalBackdrop,
  ModalContainer,
} from '../ModalFirstEnter/ModalFirstEnter.styled';
import { CloseBtn } from '../ModalReminder/ModalReminder.styled';

import { Transaction } from 'components/Transaction/Transaction';

import { addIconField, sortedTransactionsAll } from 'pages/Planning/Planning';
import useEscKeyHandler from 'hooks/useEscKeyHandler';

const modalRoot = document.querySelector('#modal-root');
export const HasRunContext = createContext(false);

export const HasRunProvider = ({ children }) => {
  const [hasRun, setHasRun] = useState(false);

  return (
    <HasRunContext.Provider value={{ hasRun, setHasRun }}>
      {children}
    </HasRunContext.Provider>
  );
};
export const ModalOverduePayment = ({ onClose, debts, isLoading }) => {
  const { t } = useTranslation();

  const handleBackdropClick = evt => {
    if (evt.target === evt.currentTarget) {
      onClose();
    }
  };

  useEscKeyHandler(onClose);

  return (
    !isLoading &&
    createPortal(
      <ModalBackdrop onClick={handleBackdropClick}>
        <ModalContainer
          style={{
            padding: 0,
            maxHeight: 'min(88vh, 640px)',
            overflow: 'hidden',
            width: 'min(96vw, 520px)',
            position: 'relative',
            top: 'auto',
            left: 'auto',
            transform: 'none',
          }}
        >
          <CloseBtn
            type="button"
            onClick={onClose}
            aria-label={t('madalGeneral.close')}
            style={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 2,
            }}
          >
            <X size={18} color="#FF7601" />
          </CloseBtn>
          <div className="max-h-[min(88vh,640px)] overflow-y-auto p-5 md:p-6">
            <Transaction
              transactions={sortedTransactionsAll(addIconField(debts))}
              allTransactions={false}
              tableHeadingSelect={false}
              deleteType={'debt'}
              overDueType={true}
            />
          </div>
        </ModalContainer>
      </ModalBackdrop>,
      modalRoot
    )
  );
};
